import React, { useEffect, useRef, useState } from "react";
import Navtop from "../Nav/Navtop";
import './dashboard.scss';
import Graph from "./Graph";
import Select from 'react-select';
import  map from 'highcharts/modules/map';
import Highcharts from 'highcharts';
import Inelogo from '../../Utils/img/ine.svg';
import axios from "axios";
import { Button, Col, Row, Table, Skeleton, Spin } from 'antd';
import { LeftOutlined, SearchOutlined } from '@ant-design/icons';

map(Highcharts);

export default function ContentDashboard() {
    const [searchIndicador, setSearchIndicador] = useState({ value: 'Indicador 404', label: 'Indicador 404' });
    const clearIndicador = useRef();
    const [subtitle, setSubtitle] = useState('Indicador 404');
    let titleGraph = '';
    const [searchEntidad, setSearchEntidad] = useState({ value: 'municipio', abrv:'Municipio', label: "NACIONAL POR MUNICIPIO" });
    const [filtroEntidad, setFiltroEntidad] = useState({ value: '', abrv:'Nacional', label: "NACIONAL POR MCPIO." });
    const [seacrhDistrito, setSeacrhDistrito] = useState({ value: '', abrv:'', label: "ENTIDAD POR SECC." });
    const [showEntids, setShowEntids] = useState([]);
    const [showDistritos, setShowDistritos] = useState([]);
    const entidsList = [];
    const distritosList = [];
    const entidsListSearch = [];
    const [popMenu, setPopMenu ] = useState(false);
    const [mapHome, setMapHome] = useState(false);
    const indicadores = [];
    const [loadGraph, setLoadGraph] = useState(false);
    const [viewEntMun, setViewEntMun] = useState(true);
    const [viewDistSec, setViewDistSec] = useState(false);
    const [ mpArray, setMpArray ] = useState([]);
    /**View Table */
    const [ viewTableTop, setviewTableTop ] = useState(false);
    const [ dataTable, setDataTable ] = useState([]);
    /**Graph */
    const [mapGraph, setMapGraph ] = useState({});
    const [rackmy, setRackmy ] = useState({});
    const [rackmn, setRackmn] = useState({});
    const [graphCircle, setGraphCircle] = useState({});
    const [graphBar, setGraphBar] = useState({});
    const [loading, setLoading] = useState(false);
    const [preloading, setPreloading] = useState(false);

    indicadores.push(
        { value: 'Indicador 404', label: 'Indicador 404' },
        { value: 'SED', label: 'SED' },
        { value: 'Recontrataciones SE/CAE', label: 'Recontrataciones SE/CAE' },
        { value: 'SustitucionesSE/CAE', label: 'SustitucionesSE/CAE' },
        { value: 'Inseguridad SE/CAE', label: 'Inseguridad SE/CAE' },
        { value: 'Incidentes JE', label: 'Incidentes JE' },
        { value: 'Casillas no instaladas', label: 'Casillas no instaladas' },
        //{ value: 'Malas prácticas', label: 'Malas prácticas' },
        { value: 'Votación atípica', label: 'Votación atípica' },
        { value: 'Factores externos-Riesgo', label: 'Factores externos-Riesgo' },
        { value: 'Factores externos-Llamadas de emergencia', label: 'Factores externos-Llamadas de emergencia' },
        { value: 'Factores externos-Enfrentamientos', label: 'Factores externos-Enfrentamientos' },
        { value: 'Factores externos-Carreteras', label: 'Factores externos-Carreteras' },
    );

    const customStylesSelect = {
        option: (provided, state) => ({
            ...provided,
            width: state.selectProps.width,
            color: state.selectProps.menuColor,
            fontSize:12,
            padding:10
        })
    };
    
    useEffect(() => {
        axios.get(window.$url+'cxentids')
        .then( response => {
            const results = response.data;
            setShowEntids(results.entidades);
        });
    }, []);
    entidsList.push(
         { value: 'municipio', abrv:'Municipio', label: "NACIONAL POR MUNICIPIO" }
     );
     entidsListSearch.push(
        { value: '', abrv:'Nacional', label: "NACIONAL POR MCPIO." }
      );
    showEntids.map( mv => {
        entidsList.push( { value: mv.entid, abrv:mv.abent, label: mv.entidad+' POR SECC.' } )
        entidsListSearch.push( { value: mv.entid, abrv:mv.abent, label: mv.entidad+' POR MCPIO.' } )
    });
    distritosList.push(
        { value: '', abrv:'', label: "ENTIDAD POR SECC." }
    );
    showDistritos.map( dist => {
        distritosList.push( { value: dist.distrito, abrv:dist.ent, label: dist.label } )
    });

    const openMenu = (() => {
        if (popMenu==false) {
            setPopMenu(true);
        } else {
            closeMenu();
        }
    });
    const closeMenu = (() => {
        setPopMenu(false);
    });
    const selectIndic = ((vr) => {
        setSearchIndicador(vr);
        graphreq(searchEntidad,vr.value,filtroEntidad.value,seacrhDistrito.value);
    });
    const searchDistrito = ((ent,dist) => {
        setShowDistritos([]);
        setSeacrhDistrito({ value: '', abrv:'', label: "ENTIDAD POR SECC." });
        distritosList.push(
            { value: '', abrv:'', label: "ENTIDAD POR SECC." }
        );
        axios.post(window.$url+'distrito',{
            'identidad': ent,
            'distrito': dist
        })
        .then( response => {
            const results = response.data;
            setShowDistritos(results.distritos);
        });
    })
    const selectEnt = ((ent) => {
        if (ent.value=='municipio') {
            setFiltroEntidad({ value: '', abrv:'Nacional', label: "NACIONAL POR MCPIO." });
            setViewEntMun(true);
            setViewDistSec(false);
            searchDistrito(ent.value,'');
        } else {
            setViewEntMun(false);
            searchDistrito(ent.value,'');
            setViewDistSec(true);
        }
        graphreq(ent,searchIndicador.value,'','');
    })
    const graphreq = ((avr,ind,muest,dist) => {
        if (ind.action=='select-option') {
            ind = 'Secciones con estrategias diferenciadas';
        }
        setSearchEntidad(avr);
        const maparray = [];
        const maparray_max = [];
        const maparray_min = [];
        const nivAtenc = [];
        const secIndic = [];
        const charupdate = require(`./map/${avr.abrv}.json`);
        const optsgraph = avr.value;
        setPreloading(true);
        if (ind=='Secciones con estrategias diferenciadas') {
            setSubtitle('Secciones con estrategias diferenciadas');
            titleGraph = 'Secciones con estrategias diferenciadas';
        } else {
            setSubtitle('en '+ind);
            titleGraph = 'en '+ind;
        }
        axios.post(window.$url+'shoctx',{
            'entidad': avr.abrv,
            'distrito':dist,
            'muestra': muest,
            'indicador': ind
        })
        .then( response => {
            const results = response.data;
            setPreloading(false);
            results.contx.map( (inf) => {
                if (optsgraph=='municipio') {
                    setMpArray(inf)
                    maparray.push({
                        'ID': inf.idmap,
                        'color': inf.smgxc,
                        'entidad': inf.ident,
                        'nombre': inf.entidad,
                        'municipio': inf.idmunicipio,
                        'title': inf.idmunicipio+'.- '+inf.nmmunicipio,
                        'distrito': inf.distrito,
                        'cabecera': inf.cabc,
                        'x1': inf.smgx1_name,
                        'x2': inf.smgx2_name,
                        'x3': inf.smgx3_name,
                        'x4': inf.smgx4_name,
                        'x5': inf.smgx5_name,
                        'x6': inf.smgx6_name,
                        'x7': inf.smgx7_name,
                        'x8': inf.smgx8_name,
                        'x9': inf.smgx9_name,
                        'x10': inf.smgx10_name,
                        'x11': inf.smgx11_name,
                        'x12': inf.smgx12_name,
                        'x13': inf.smgx13_name,
                        'value': parseInt(inf.smgx)
                    });
                } else {
                    maparray.push({
                        'SECCION': inf.seccion,
                        'color': inf.smgxc,
                        'title': inf.cabc,
                        'distrito': inf.distrito,
                        'cabecera': inf.cabera,
                        'x1': inf.smgx1_name,
                        'x2': inf.smgx2_name,
                        'x3': inf.smgx3_name,
                        'x4': inf.smgx4_name,
                        'x5': inf.smgx5_name,
                        'x6': inf.smgx6_name,
                        'x7': inf.smgx7_name,
                        'x8': inf.smgx8_name,
                        'x9': inf.smgx9_name,
                        'x10': inf.smgx10_name,
                        'x11': inf.smgx11_name,
                        'x12': inf.smgx12_name,
                        'x13': inf.smgx13_name,
                        'value': parseInt(inf.smgx)
                    });
                }
            });
            nivAtenc.push(results.nivelAtencion);
            secIndic.push(results.seccIndc);
            if (optsgraph=='municipio') {
                results.maxsec.map( (inf) => {
                    maparray_max.push(
                            {
                                name: inf.entidad + ' - Distrito:  '+ inf.distrito+' - Municipio: ' +inf.idmunicipio+'.- '+inf.municipio,
                                y: parseInt(inf.smgx),
                                color:inf.smgxc
                            }
                    );
    
                });
                results.minsec.map( (inf) => {
                    maparray_min.push(
                        {
                            name: inf.entidad + ' - Distrito:  '+ inf.distrito+' - Municipio: ' +inf.idmunicipio+'.- '+inf.municipio,
                            y: parseInt(inf.smgx),
                            color:inf.smgxc
                        }
                    );
                });
            } else {
                results.maxsec.map( (inf) => {
                    maparray_max.push(
                            {
                                name: 'Distrito: ' +inf.distrito+'.- '+inf.cabecera + ' - Sección:  '+ inf.seccion,
                                y: parseInt(inf.smgx),
                                color:inf.smgxc
                            }
                    );
    
                });
                results.minsec.map( (inf) => {
                    maparray_min.push(
                        {
                            name: 'Distrito: ' +inf.distrito+'.- '+inf.cabecera+ ' - Sección:  '+  inf.seccion,
                            y: parseInt(inf.smgx),
                            color:inf.smgxc
                        }
                    );
                });
            }
            graphupdaterequest(charupdate,maparray,maparray_max,maparray_min,optsgraph,nivAtenc,secIndic);
            setLoadGraph(true);
        });
    });
    const graphupdaterequest = ((chart,array,maxar,minar,select,nvAtec,scInc) => {
        let joinBymap = '';
        let keymaps =[];
        let tooltipNac = {};
        if (select=='municipio') {
            setViewEntMun(true);
            joinBymap = 'ID';
            keymaps.push(['ID','color','entidad','nombre','municipio','title','distrito','cabecera','x1','x2','x3','x4','x5','x6','x7','x8','x9','x10','value']);
            tooltipNac = {
                formatter: function(){
                    return '<b>Entidad: '+this.point.nombre+'</b>'+'<br>'+
                    '<b>Distrito: '+this.point.cabecera+'</b>'+'<br>'+
                    '<b>Municipio: '+this.point.title+'</b>'+'<br>'+
                    'Indicador 404: '+'<b>'+this.point.x13+'</b>'+'<br>'+
                    'SED: '+'<b>'+this.point.x1+'</b>'+'<br>'+
                    'Recontrataciones SE/CAE: '+'<b>'+this.point.x2+'</b>'+'<br>'+
                    'SustitucionesSE/CAE: '+'<b>'+this.point.x3+'</b>'+'<br>'+
                    'Inseguridad SE/CAE: '+'<b>'+this.point.x4+'</b>'+'<br>'+
                    'Incidentes JE: '+'<b>'+this.point.x5+'</b>'+'<br>'+
                    'Casillas no instaladas: '+'<b>'+this.point.x6+'</b>'+'<br>'+
                    'Votación atípica: '+'<b>'+this.point.x8+'</b>'+'<br>'+
                    'Factores externos-Riesgo: '+'<b>'+this.point.x9+'</b>'+'<br>'+
                    'Factores externos-Llamadas de emergencia: '+'<b>'+this.point.x10+'</b>'+'<br>'+
                    'Factores externos-Enfrentamientos: '+'<b>'+this.point.x11+'</b>'+'<br>'+
                    'Factores externos-Carreteras: '+'<b>'+this.point.x12+'</b>'+'<br>'
               }
           }
        
        } else {
            setViewEntMun(false);
            joinBymap = 'SECCION';
            keymaps.push(['SECCION','color','title','distrito','cabecera','x1','x2','x3','x4','x5','x6','x7','x8','x9','x10','value']);
            tooltipNac = {
                formatter: function(){
                    return '<b>Distrito: '+this.point.title+'</b>'+'<br>'+
                    'Seccion: '+'<b>'+this.point.SECCION+'</b>'+'<br>'+
                    'Indicador 404: '+'<b>'+this.point.x13+'</b>'+'<br>'+
                    'SED: '+'<b>'+this.point.x1+'</b>'+'<br>'+
                    'Recontrataciones SE/CAE: '+'<b>'+this.point.x2+'</b>'+'<br>'+
                    'SustitucionesSE/CAE: '+'<b>'+this.point.x3+'</b>'+'<br>'+
                    'Inseguridad SE/CAE: '+'<b>'+this.point.x4+'</b>'+'<br>'+
                    'Incidentes JE: '+'<b>'+this.point.x5+'</b>'+'<br>'+
                    'Casillas no instaladas: '+'<b>'+this.point.x6+'</b>'+'<br>'+
                    'Votación atípica: '+'<b>'+this.point.x8+'</b>'+'<br>'+
                    'Factores externos-Riesgo: '+'<b>'+this.point.x9+'</b>'+'<br>'+
                    'Factores externos-Llamadas de emergencia: '+'<b>'+this.point.x10+'</b>'+'<br>'+
                    'Factores externos-Enfrentamientos: '+'<b>'+this.point.x11+'</b>'+'<br>'+
                    'Factores externos-Carreteras: '+'<b>'+this.point.x12+'</b>'+'<br>'
               }
           }
        }
        setMapGraph({
            chart: {
                backgroundColor: "transparent",
                plotBorderColor: "transparent",
                map: chart,
                height:800,
            },
            accessibility: {
                enabled: false
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: 'Contexto Nacional en Materia de Logística y Operación de Campo',
                align: 'center',
            },
            tooltip: {
                enabled:true,
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
                itemDistance:0,
                margin:0,
                padding:4,
            },
            mapNavigation: {
                enabled: true,
                enableButtons: true,
                buttonOptions: {
                    verticalAlign: 'bottom'
                },
                enableMouseWheelZoom: false,
            },
            plotOptions: {
                map: {
                    borderWidth:2,
                    borderColor:'#ffffff',
                    dataLabels: {
                        enabled: true,
                        style: {
                            textOutline: false,
                            fontWeight:'500',
                            fontSize:10
                        },
                        formatter: function() {
                            if (this.point.value != null) {
                                return this.point.name;
                                //return this.point.value +'%';
                            } else {
                                return '';
                            }
                        }
                    }
                }
            },
            tooltip: tooltipNac,
            series: [
                {
                    name: 'Municipios',
                    data: array,
                    keys: keymaps,
                    joinBy: joinBymap,
                    accessibility: {
                      exposeAsGroupOnly: true
                    },
                    borderColor:'#d7d7d7',
                    borderWidth:.2,
                    point:{
                        events: {
                            click: function () {
        
                            }
                        },
                    },
                }
            ]
        });
        setRackmy({
            chart:{
                backgroundColor: "transparent",
                plotBorderColor: "transparent",
                type: 'bar',
            },
            exporting: {
                filename: 'Secciones con mayor indice '+titleGraph,
            },
            title: {
                text: 'Secciones con mayor indice '+titleGraph,
            },
            accessibility: {
                enabled: false
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                type: 'category',
                min:0,
                max:7,
                scrollbar: {
                    enabled: true,
                    showFull: false,
                    step: 0.1
                },
                labels: {
                    style: {
                        fontSize:'8px'
                    }
                }
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: null
                }
            },
            tooltip: {
                shared: true,
                useHTML: true,
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        style: {
                            textOutline: false
                        }
                    }
                }
            },
            series: [
                {
                    name: '',
                    data: maxar,
                }
            ]
        });
        setRackmn({
            chart:{
                backgroundColor: "transparent",
                plotBorderColor: "transparent",
                type: 'bar',
            },
            exporting: {
                filename: 'Secciones con menor indice '+titleGraph,
            },
            title: {
                text: 'Secciones con menor indice '+titleGraph,
            },
            accessibility: {
                enabled: false
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                type: 'category',
                min:0,
                max:7,
                scrollbar: {
                    enabled: true,
                    showFull: false,
                    step: 0.1
                },
                labels: {
                    style: {
                        fontSize:'8px'
                    }
                }
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: null
                }
            },
            tooltip: {
                shared: true,
                useHTML: true,
                pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                        style: {
                            textOutline: false
                        }
                    }
                }
            },
            series: [
                {
                    name: '',
                    data: minar,
                    color: 'rgba(255,83,185,1)'
                }
            ]
        });
        setGraphCircle({
            chart:{
                backgroundColor: "transparent",
                plotBorderColor: "transparent",
                type: 'pie',
            },
            exporting: {
                filename:'Total de secciones por nivel de atención'
            },
            title: {
                text: 'Total de secciones por nivel de atención',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: ''
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: null
                },
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                }
            },
            legend: {
                enabled: true
            },
            tooltip: {
                enabled: true,
                pointFormat: '<b>{point.y}% </b>(<b>{point.v}</b>)'
            },
            credits: {
                enabled:false
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    showInLegend: true,
                    dataLabels: {
                        enabled: true,
                        format:'<b>{point.name} </b>{point.y} %',
                        style: {
                            textOutline: false
                        }
                    },
                    point : {
                        events: {
                            click: function() {
                                console.log(this.name);
                                if (this.name=='Seguimiento') {
                                    searcAtenc(0);
                                } else if (this.name=='Prevención') {
                                    searcAtenc(1);
                                } else if (this.name=='Atención') {
                                    searcAtenc(2);
                                } else if (this.name=='Intervención') {
                                    searcAtenc(3);
                                }
                            }
                        }
                    }
                }
            },
            series: [
                {
                    name: '',
                    colorByPoint: true,
                    data: [
                        {
                            name: 'Seguimiento',
                            color: '#00B050',
                            y: parseFloat(nvAtec[0][0].porc_cero),
                            v: nvAtec[0][0].t_cero
                        },{
                            name: 'Prevención',
                            color: '#FFFF00',
                            y: parseFloat(nvAtec[0][0].porc_one),
                            v: nvAtec[0][0].t_one
                        },{
                            name: 'Atención',
                            color: '#ED7D31',
                            y: parseFloat(nvAtec[0][0].porc_two),
                            v: nvAtec[0][0].t_two
                        },{
                            name: 'Intervención',
                            color: '#FF0000',
                            y: parseFloat(nvAtec[0][0].porc_there),
                            v: nvAtec[0][0].t_there
                        },
                    ]
                }
            ]
        });
        setGraphBar({
            chart:{
                backgroundColor: "transparent",
                plotBorderColor: "transparent",
                type: 'column',
            },
            exporting: {
                filename:'Total de secciones por indicador'
            },
            title: {
                text: 'Total de secciones por indicador',
            },
            subtitle: {
                text: scInc[0][0].t_secc+' secciones',
            },
            xAxis: {
                categories: [
                    'SED',
                    'Recontrataciones SE/CAE',
                    'SustitucionesSE/CAE',
                    'Inseguridad SE/CAE',
                    'Incidentes JE',
                    'Casillas no instaladas',
                    'Votación atípica',
                    'Factores externos-Riesgo',
                    'Factores externos-Llamadas de emergencia',
                    'Factores externos-Enfrentamientos',
                    'Factores externos-Carreteras',
                    'Indicador 404']
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: null
                },
                labels: {
                    format: '{value}%'
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: true,
                pointFormat: '<b>{point.y}% </b>(<b>{point.v}</b>)'
            },
            credits: {
                enabled:false
            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        format:'<b>{point.name} </b>{point.y} %',
                        style: {
                            textOutline: false
                        }
                    },
                    point : {
                        events: {
                            click: function() {
                                //setviewTableTop(true);
                            }
                        }
                    }
                }
            },
            series: [
                {
                    name: '',
                    colors: ['#d5007f', '#d950a2', 'rgba(217,80,162,0.6)', '#db6AAE', 'rgba(219,106,174,0.6)','#d97eb4', 'rgba(217,126,180,0.6)', '#d791bb', 'rgba(215,145,187,0.6)','#d8aec7','rgba(216,174,216,0.6)'],
                    colorByPoint: true,
                    data: [
                        {
                            y: parseFloat(scInc[0][0].porc_x1),
                            v: scInc[0][0].t_x1
                        },{
                            y: parseFloat(scInc[0][0].porc_x2),
                            v: scInc[0][0].t_x2
                        },{
                            y: parseFloat(scInc[0][0].porc_x3),
                            v: scInc[0][0].t_x3
                        },{
                            y: parseFloat(scInc[0][0].porc_x4),
                            v: scInc[0][0].t_x4
                        },{
                            y: parseFloat(scInc[0][0].porc_x5),
                            v: scInc[0][0].t_x5
                        },{
                            y: parseFloat(scInc[0][0].porc_x6),
                            v: scInc[0][0].t_x6
                        },{
                            y: parseFloat(scInc[0][0].porc_x8),
                            v: scInc[0][0].t_x8
                        },{
                            y: parseFloat(scInc[0][0].porc_x9),
                            v: scInc[0][0].t_x9
                        },{
                            y: parseFloat(scInc[0][0].porc_x10),
                            v: scInc[0][0].t_x10
                        },{
                            y: parseFloat(scInc[0][0].porc_x11),
                            v: scInc[0][0].t_x11
                        },{
                            y: parseFloat(scInc[0][0].porc_x12),
                            v: scInc[0][0].t_x12
                        },{
                            y: parseFloat(scInc[0][0].porc_clasconj),
                            v: scInc[0][0].t_clasconj
                        },
                    ]
                }
            ]
        });
        setMapHome(true);
    })
    const seacrent = ((ent) => {
        setSeacrhDistrito({ value: '', abrv:'', label: "ENTIDAD POR SECC." });
        setViewDistSec(false);
        if (ent.value!=='') {
            searchDistrito(ent.value,'');   
        }
        setFiltroEntidad(ent);
        graphreq(searchEntidad,searchIndicador.value,ent.value,'');
    })
    const seacrdist = ((dist) => {
        setSeacrhDistrito(dist);
        graphreq(searchEntidad,searchIndicador.value,filtroEntidad.value,dist.value);
    })

    useEffect(() => {
        graphreq(searchEntidad,searchIndicador.value,filtroEntidad.value,seacrhDistrito.value);
    }, []);

    const columnsDemo = [
        {
            title: 'Entidad',
            dataIndex: 'entidad',
            key:'entidad',
            filterSearch: true,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Dtto.',
            dataIndex: 'distrito',
            key:'distrito',
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Municipio',
            dataIndex: 'municipio',
            key:'municipio',
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Secciones',
            dataIndex: 'seccion',
            key:'seccion',
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'SED',
            dataIndex: 'x1',
            key:'x1',
            render: (text, row) => <div>
                { row.x1==0 &&<span>-</span>}
                { row.x1==1 &&<span className="astneg">*</span>}
                { row.x1==2 &&<span className="astneg">*</span>}
                { row.x1==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Recontrataciones SE/CAE',
            dataIndex: 'x2',
            key:'x2',
            render: (text, row) => <div>
                { row.x2==0 &&<span>-</span>}
                { row.x2==1 &&<span className="astneg">*</span>}
                { row.x2==2 &&<span className="astneg">*</span>}
                { row.x2==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'SustitucionesSE/CAE',
            dataIndex: 'x3',
            key:'x3',
            render: (text, row) => <div>
                { row.x3==0 &&<span>-</span>}
                { row.x3==1 &&<span className="astneg">*</span>}
                { row.x3==2 &&<span className="astneg">*</span>}
                { row.x3==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Inseguridad SE/CAE',
            dataIndex: 'x4',
            key:'x4',
            render: (text, row) => <div>
                { row.x4==0 &&<span>-</span>}
                { row.x4==1 &&<span className="astneg">*</span>}
                { row.x4==2 &&<span className="astneg">*</span>}
                { row.x4==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Incidentes JE',
            dataIndex: 'x5',
            key:'x5',
            render: (text, row) => <div>
                { row.x5==0 &&<span>-</span>}
                { row.x5==1 &&<span className="astneg">*</span>}
                { row.x5==2 &&<span className="astneg">*</span>}
                { row.x5==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Casillas no instaladas',
            dataIndex: 'x6',
            key:'x6',
            render: (text, row) => <div>
                { row.x6==0 &&<span>-</span>}
                { row.x6==1 &&<span className="astneg">*</span>}
                { row.x6==2 &&<span className="astneg">*</span>}
                { row.x6==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Votación atípica',
            dataIndex: 'x8',
            key:'x8',
            render: (text, row) => <div>
                { row.x8==0 &&<span>-</span>}
                { row.x8==1 &&<span className="astneg">*</span>}
                { row.x8==2 &&<span className="astneg">*</span>}
                { row.x8==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Acciones delictivas en materia electoral',
            dataIndex: 'x9',
            key:'x9',
            render: (text, row) => <div>
                { row.x9==0 &&<span>-</span>}
                { row.x9==1 &&<span className="astneg">*</span>}
                { row.x9==2 &&<span className="astneg">*</span>}
                { row.x9==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Factores externos-Llamadas de emergencia',
            dataIndex: 'x10',
            key:'x10',
            render: (text, row) => <div>
                { row.x10==0 &&<span>-</span>}
                { row.x10==1 &&<span className="astneg">*</span>}
                { row.x10==2 &&<span className="astneg">*</span>}
                { row.x10==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Factores externos-Enfrentamientos',
            dataIndex: 'x11',
            key:'x11',
            render: (text, row) => <div>
                { row.x11==0 &&<span>-</span>}
                { row.x11==1 &&<span className="astneg">*</span>}
                { row.x11==2 &&<span className="astneg">*</span>}
                { row.x11==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        },{
            title: 'Factores externos-Carreteras',
            dataIndex: 'x12',
            key:'x12',
            render: (text, row) => <div>
                { row.x12==0 &&<span>-</span>}
                { row.x12==1 &&<span className="astneg">*</span>}
                { row.x12==2 &&<span className="astneg">*</span>}
                { row.x12==3 &&<span className="astneg">*</span>}
            </div>,
            showSorterTooltip: false,
            sorter: (a, b) => a.age - b.age,
        }
    ];
    
    const searcAtenc = ((atec) => {
        setviewTableTop(true);
        setDataTable([]);
        setLoading(true);
        axios.post(window.$url+'searchinc',{
            'entidad': searchEntidad.abrv,
            'distrito':seacrhDistrito.value,
            'muestra': filtroEntidad.value,
            'indicador': searchIndicador.value,
            'atenc': atec
        })
        .then( response => {
            const results = response.data;
            setDataTable(results.tabinf);
            setLoading(false);
        });
    })
    
    return(
        <>
            <Navtop/>
            <div className="dashboard">
                <div className="dashboard__ftr">
                    <Select
                        styles={customStylesSelect}
                        className="dashboard__ftr--fil"
                        placeholder="Seleccione un indicador"
                        value={searchIndicador}
                        isSearchable={false}
                        options={indicadores}
                        onChange={selectIndic}/>
                </div>
                {loadGraph &&
                    <Spin spinning={preloading}>
                        <div className="dashboard__tabgraph">
                            { viewTableTop!==false &&
                                <div className="dashboard__tabgraph__secc__btn">
                                    <Button onClick={() => setviewTableTop(false)} icon={<LeftOutlined />} className="dashboard__tabgraph__secc__btn--btn">
                                        VER GRAFICAS
                                    </Button>
                                </div>
                            }
                            { viewTableTop!==true &&
                                <Row>
                                    <Col span={24}>
                                        <Graph  highcharts={Highcharts} options={graphCircle} type="chart" update={true}/>
                                    </Col>
                                    {/* <Col span={12}>
                                        <Graph  highcharts={Highcharts} options={rackmy} type="chart" update={true}/>
                                    </Col> */}
                                </Row>
                            }
                            { viewTableTop &&
                                <div className="respotable">
                                    <Table
                                    size="small"
                                    loading={loading}
                                    columns={columnsDemo}
                                    dataSource={dataTable}/>
                                </div>
                            }
                        </div>
                    </Spin>
                }
                <Spin spinning={preloading}>
                    <div className="spc">
                        {loadGraph && 
                            <div>
                                <Graph highcharts={Highcharts} options={mapGraph} type="mapChart" update={mapHome}/>
                                <div className="lblgraph">
                                    {/* <div className="lblgraph--lbl">Fuente: <img className="lblgraph--ico" src={Inelogo} alt="Logotipo INE"></img></div> */}
                                </div>
                            </div>
                        }
                    </div>
                </Spin>
                <Spin spinning={preloading}>
                    <div>
                        {loadGraph && <Graph  highcharts={Highcharts} options={graphBar} type="chart" update={true}/>}
                    </div>
                </Spin>
                <div className="dashboard__clm">
                    
                    {/* <div>
                        {loadGraph && <Graph highcharts={Highcharts} options={rackmn} type="chart" update={true}/>}
                    </div> */}
                </div>
                <section>
                    <div className="filtersearch" onClick={openMenu}>
                        <i className="lni lni-search-alt"></i>
                    </div>
                    { popMenu &&
                        <div className="navsearch">
                            <div className="navsearch__btn">
                                <div className="spdc">
                                    <Select
                                        styles={customStylesSelect}
                                        className="dashboard__ftr--fil"
                                        placeholder="Seleccione una Entidad"
                                        value={searchEntidad}
                                        isSearchable={false}
                                        options={entidsList}
                                        onChange={selectEnt}/>
                                </div>
                                {viewEntMun && 
                                    <div className="spdc">
                                        <Select
                                            styles={customStylesSelect}
                                            className="dashboard__ftr--fil"
                                            placeholder="Seleccione una Entidad"
                                            value={filtroEntidad}
                                            isSearchable={false}
                                            options={entidsListSearch}
                                            onChange={seacrent}/>
                                    </div>
                                }
                                { viewDistSec && 
                                    <div className="spdc">
                                        <Select
                                            styles={customStylesSelect}
                                            className="dashboard__ftr--fil"
                                            placeholder="Seleccione un Distrito"
                                            value={seacrhDistrito}
                                            isSearchable={false}
                                            options={distritosList}
                                            onChange={seacrdist}/>
                                    </div>
                                }
                                <div className="btnclose" onClick={closeMenu}>
                                    CERRAR
                                </div>
                            </div>
                        </div>
                    }
                </section>
            </div>
        </>
    );
}